import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { UI_COLORS } from "../../config";

export default function LoadingPlaceholder({
  tip = "Loading keys...",
  subtitle = "Please wait while we fetch keys",
  minWidth = 240,
}) {
  return (
    <div className="h-full flex flex-col rounded-md">
      <div className="h-full flex-grow flex items-center justify-center bg-white">
        <div
          className="h-full flex items-center justify-center text-center p-8 flex-col"
          style={{ minWidth }}
        >
          <Spin
            tip={tip}
            indicator={<LoadingOutlined style={{ fontSize: 50, color: UI_COLORS.primary }} spin />}
          />
          <p className="mt-4 text-gray-500 font-medium">{tip}</p>
          <p className="mt-2 text-sm text-gray-400">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}